/* eslint-disable */
const defaultOptions = {
  headers: {
    'content-type': 'application/json;charset=UTF-8',
  },
};

interface RequestOptions {
  method?: string;
  [key: string]: any;
}

export const get = async (url: string, options?: object) =>
  request(url, undefined, {
    ...options,
    method: 'GET',
  });

export const post = async (url: string, data?: object, options?: object) =>
  request(url, data, {
    ...options,
    method: 'POST',
  });

export const put = async (url: string, data?: object, options?: object) =>
  request(url, data, {
    ...options,
    method: 'PUT',
  });

export const del = async (url: string, data?: object, options?: object) =>
  request(url, data, {
    ...options,
    method: 'DELETE',
  });

const request = async (
  url: string,
  data?: object,
  options?: RequestOptions,
) => {
  let response;
  try {
    const body = options?.method === 'GET' ? undefined : JSON.stringify(data);
    response = await fetch(url, {
      ...defaultOptions,
      ...options,
      body,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (e) {
    console.log('Request failed', e);
    throw e;
  }
};
